module.exports = __webpack_public_path__ + "media/images/div_lens/div-families-39e7da369d65f0b54b45f0eede011d63.png";